(function () {
  if (window.cupcuddleInfiniteScroll) return;
  window.cupcuddleInfiniteScroll = true;

  const bind = (container) => {
    const grid = container.querySelector('#product-grid');
    const holder = container.querySelector('[data-infinite-scroll]');
    if (!grid || !holder || holder.dataset.bound === 'true') return;

    holder.dataset.bound = 'true';
    let nextUrl = holder.dataset.nextUrl || '';
    let loading = false;
    let loaded = false;
    const sentinel = holder.querySelector('[data-infinite-sentinel]');
    const status = holder.querySelector('[data-infinite-status]');

    if (!nextUrl || !sentinel) {
      holder.hidden = true;
      return;
    }

    const loadMore = () => {
      if (loading || !nextUrl) return;
      loading = true;
      if (status) status.hidden = false;

      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', grid.dataset.id);

      fetch(url.toString())
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const items = doc.querySelectorAll('#product-grid > li');
          items.forEach((item) => grid.appendChild(item));

          const nextHolder = doc.querySelector('[data-infinite-scroll]');
          nextUrl = nextHolder && nextHolder.dataset.nextUrl ? nextHolder.dataset.nextUrl : '';
          loaded = true;
          if (!nextUrl) {
            holder.hidden = true;
            observer.disconnect();
          }
        })
        .catch(() => {
          loaded = false;
        })
        .finally(() => {
          loading = false;
          if (status) status.hidden = true;
          if (loaded && nextUrl && sentinel.getBoundingClientRect().top < window.innerHeight + 600) {
            loadMore();
          }
          loaded = false;
        });
    };

    const nearEnd = () => sentinel.getBoundingClientRect().top < window.innerHeight + 600;

    const onScroll = () => {
      if (nearEnd()) loadMore();
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) loadMore();
      },
      { rootMargin: '600px 0px' }
    );

    observer.observe(sentinel);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  };

  const boot = () => {
    document.querySelectorAll('#ProductGridContainer').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  const watch = () => {
    const container = document.getElementById('ProductGridContainer');
    if (!container || container.dataset.infiniteWatch === 'true') return;
    container.dataset.infiniteWatch = 'true';
    new MutationObserver(boot).observe(container, { childList: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
